// action types
import ApiService from "../api.service";
import {SET_ERROR} from "./auth.module";
import {CREATE_STAFF} from "./user/users.module";

export const USER_PROFILE = "userProfile";
export const UPDATE_PERSONAL_INFO = "updateUserPersonalInfo";
export const UPDATE_ACCOUNT_INFO = "updateUserAccountInfo";

// profile
export const GET_GENERAL_INFO = "profile/general-info";
export const SAVE_GENERAL_INFO = "profile/general-info/save";
export const SAVE_IDENTITY_CARD_INFO = "profile/identity-card-info/save";
export const SAVE_BANK_ACCOUNT = "profile/bank-account/save";
export const GENERAL_WORKING_INFO = "profile/general-working-info";
export const POST_GENERAL_WORKING_INFO = "profile/post-general-working-info";
export const GET_WORKING_PROCESS = "profile/working-process";
export const GET_DETAIL_BOND_VALUE= 'staff/bonds/all'

// mutation types
export const SET_USER_PROFILE = "setUserProfile";

const state = {
    errors: null,
    user_profile: {
        data: {
            avatar: "",
            profile: {
                account_type: {
                    name: ""
                }
            }
        }
    },
};

const getters = {
    userProfile(state) {
        return state.user_profile;
    },
};

const actions = {
    [USER_PROFILE](context, payload) {
        return new Promise(resolve => {
            ApiService.query("/get-user-data/" + payload.id)
                .then(({ data }) => {
                    context.commit(SET_USER_PROFILE, data);
                    resolve(data);
                })
        });
    },
    [UPDATE_PERSONAL_INFO](context, payload) {
        return new Promise(resolve => {
            ApiService.post('/update-user/' + JSON.parse(localStorage.getItem('user')).user.id, payload).then(({data}) => {
                context.commit(SET_USER_PROFILE, data);
                resolve(data);
            }).catch(({response}) => {
                if (response?.data?.data?.message_validate_form) {
                    context.commit(SET_ERROR, response.data.data.message_validate_form);
                } else {
                    context.commit(SET_ERROR, response && response.data ? response.data.message : '');
                }
            });
        });
    },

    [GET_GENERAL_INFO](context, payload) {
        return new Promise(resolve => {
            ApiService.query(`${GET_GENERAL_INFO}/`+ payload.id)
                .then(({ data }) => {
                    resolve(data);
                })
        });
    },
    [SAVE_IDENTITY_CARD_INFO](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.post(`${SAVE_IDENTITY_CARD_INFO}/` + payload.id, payload).then(({data}) => {
                resolve(data);
            }).catch(({response}) => {
                reject(response)
            });
        })
    },
    [SAVE_GENERAL_INFO](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.post(`${GET_GENERAL_INFO}/` + payload.id, payload).then(({data}) => {
                resolve(data);
            }).catch(({response}) => {
                reject(response)
            });
        })
    },
    [SAVE_BANK_ACCOUNT](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.post(`${SAVE_BANK_ACCOUNT}/` + payload.id, payload).then(({data}) => {
                resolve(data);
            }).catch(({response}) => {
                reject(response)
            });
        })
    },
    [GENERAL_WORKING_INFO](context, id) {
        return new Promise(resolve => {
            ApiService.query(`${GENERAL_WORKING_INFO}/`+ id)
                .then(({ data }) => {
                    resolve(data);
                })
        });
    },
    [POST_GENERAL_WORKING_INFO](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.post(`${GENERAL_WORKING_INFO}/` + payload.id, payload).then(({data}) => {
                resolve(data);
            }).catch(({response}) => {
                reject(response)
            });
        })
    },
    [GET_WORKING_PROCESS](context, id) {
        return new Promise(resolve => {
            ApiService.query(`${GET_WORKING_PROCESS}/`+ id)
                .then(({ data }) => {
                    resolve(data);
                })
        });
    },

    [GET_DETAIL_BOND_VALUE](context, payload) {
        return new Promise(resolve => {
            ApiService.query(`${GET_DETAIL_BOND_VALUE}`, payload)
                .then(({ data }) => {
                    resolve(data);
                })
        });
    },

};

const mutations = {
    [SET_ERROR](state, error) {
        state.errors = error;
    },
    [SET_USER_PROFILE](state, user_profile) {
        state.user_profile = user_profile;
    },
    // [SET_PERSONAL_INFO](state, user_personal_info) {
    //     state.user_personal_info = user_personal_info;
    // },
};

export default {
    state,
    actions,
    mutations,
    getters
};
